package com.gsb.vyapar.bhagya.presentation.auth.view

import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.verticalScroll
import androidx.compose.material.MaterialTheme
import androidx.compose.material.Surface
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.platform.LocalUriHandler
import androidx.compose.ui.unit.dp
import com.gsb.vyapar.bhagya.getPhoneNumber
import com.gsb.vyapar.bhagya.interactor.event.UiEvents
import com.gsb.vyapar.bhagya.interactor.manager.StateManager.launchDefault
import com.gsb.vyapar.bhagya.interactor.uistate.UiState
import com.gsb.vyapar.bhagya.presentation.auth.util.login
import com.gsb.vyapar.bhagya.presentation.common.button.GVBButton
import com.gsb.vyapar.bhagya.presentation.common.edittext.MobileUserIdEditText
import com.gsb.vyapar.bhagya.presentation.common.edittext.UserIdPasswordEditText
import com.gsb.vyapar.bhagya.presentation.common.image.CommonImage
import com.gsb.vyapar.bhagya.presentation.common.platformImePadding
import com.gsb.vyapar.bhagya.presentation.common.text.Text14RegularB
import com.gsb.vyapar.bhagya.presentation.common.toolbar.Toolbar
import com.gsb.vyapar.bhagya.theme.primary
import com.gsb.vyapar.bhagya.theme.splash
import com.gsb.vyapar.bhagya.util.getPrivacyUrl
import com.gsb.vyapar.bhagya.util.getTermsUrl

@Composable
fun LoginWithPasswordView(uiState: UiState, onTriggerEvent: (UiEvents) -> Unit) {
    val uriHandler = LocalUriHandler.current
    var userIdOrMobile by remember { mutableStateOf("") }
    var password by remember { mutableStateOf("") }
    Surface(
        modifier = Modifier.fillMaxSize(),
        color = MaterialTheme.colors.background
    ) {
        Column(
            modifier = Modifier.fillMaxWidth()
        ) {
            Toolbar("Login with Password")
            Column(
                modifier = Modifier.verticalScroll(rememberScrollState()).fillMaxWidth()
                    .padding(16.dp).platformImePadding(),
                horizontalAlignment = Alignment.CenterHorizontally
            ) {
                Spacer(Modifier.height(15.dp))
                CommonImage(splash, 200.dp, 200.dp)
                Spacer(Modifier.height(15.dp))
                MobileUserIdEditText(userIdOrMobile) { userIdOrMobile = it }
                Spacer(Modifier.height(8.dp))
                UserIdPasswordEditText(password) { password = it }
                Spacer(Modifier.height(16.dp))
                GVBButton(text = "Login") {
                    login(userIdOrMobile, password)
                }
            }
            Spacer(Modifier.weight(1f))
            Row(modifier = Modifier.fillMaxWidth().padding(24.dp), horizontalArrangement = Arrangement.SpaceBetween) {
                Text14RegularB("Privacy Policy", primary, Modifier.clickable { uriHandler.openUri(getPrivacyUrl()) })
                Text14RegularB("Terms & Conditions", primary, Modifier.clickable { uriHandler.openUri(getTermsUrl()) })
            }
        }
    }
    LaunchedEffect(Unit) {
        launchDefault {
            userIdOrMobile = getPhoneNumber().orEmpty()
        }
    }
}